import { useStore } from '@mirai/data-sources';
import { Slider, styles, Text, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { Environment } from './components';
import { extractImageMarkdown, formatText } from './helpers';
import * as style from './Message.module.css';

// ! TODO: Refacto use of intent/response vs lisa.intent/response
const Message = ({ busy = false, synapse, text, ...others }) => {
  const containerRef = useRef();
  const { value: { urlParams = {} } = {} } = useStore();

  const [containerWidth, setContainerWidth] = useState();
  const { imageUrls, text: textWithoutInlineImage } = extractImageMarkdown(text);

  const { testId, ...synapseProps } = others;

  useEffect(() => {
    if (!synapse || !containerRef?.current) return setContainerWidth();

    const updateWidth = () => {
      const node = containerRef.current;
      const nodeWidth = node.offsetWidth;
      const parentWidth = node.parentElement?.offsetWidth;
      const nextWidth = parentWidth && parentWidth > nodeWidth ? parentWidth : nodeWidth;
      setContainerWidth(nextWidth > 0 ? nextWidth : undefined);
    };
    updateWidth();

    window.addEventListener('resize', updateWidth);

    return () => window.removeEventListener('resize', updateWidth);
  }, [synapse]);

  return (
    <View testId={testId} wide>
      <View row wide className={styles(style.message, synapse && style.synapse)}>
        <View
          ref={synapse ? containerRef : undefined}
          className={styles(style.content, synapse && style.synapse, busy && style.busy)}
        >
          {busy ? (
            <View className={style.spinner} />
          ) : (
            <>
              <Text className={style.text}>{formatText(textWithoutInlineImage)}</Text>
              {imageUrls.length > 0 && containerWidth > 0 ? (
                <Slider
                  height={containerWidth * 0.66}
                  images={imageUrls}
                  width={containerWidth}
                  className={style.gallery}
                />
              ) : null}
            </>
          )}
        </View>
      </View>

      {!busy && synapse && urlParams.sarai === 'environment' && (
        <Environment {...{ synapse, ...others, ...synapseProps }} />
      )}
    </View>
  );
};

Message.propTypes = {
  busy: PropTypes.bool,
  synapse: PropTypes.bool,
  text: PropTypes.string,
};

export { Message };
